export interface Mode {
  id: string;
  name: string;
  instructions: string;
  clarityLevel: ModeOptions;
  thoroughnessLevel: ModeOptions;
  interactivityLevel: ModeOptions;
  isCustom: boolean;
}

export type ModeOptions = 'low' | 'medium' | 'high';

export const modes: Mode[] = [
  {
    id: 'qa-default-mode',
    name: 'Chat',
    instructions: "Gives quick, friendly answers",
    clarityLevel: 'medium',
    thoroughnessLevel: 'medium',
    interactivityLevel: 'high',
    isCustom: false
  },
  {
    id: 'tutor-default-mode',
    name: 'Tutor',
    instructions: "Explains things step by step in a clear, gentle way.",
    clarityLevel: 'high',
    thoroughnessLevel: 'high',
    interactivityLevel: 'high',
    isCustom: false
  }
];
